import React, { Suspense } from 'react';
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom';
import { LoadingIndicator } from 'sharedComponents';
import SingleLeftPanelItem from './SingleLeftPanelItem';
import './style.scss';
import PropTypes from 'prop-types';

const LeftNavLayoutComponent = ({
    navigationItems,
    defaultRoute,
    basePath
}) => {
    const history = useHistory();
    const location = useLocation();

    const handleNavItemClick = (item) => {
        if (item.path && location.pathname !== item.path) {
            history.push(item.path);
        }
        if (item.onClick) {
            item.onClick();
        }
    };

    const isActiveRoute = (itemPath) => {
        return location.pathname.includes(itemPath);
    };

    return (
        <div className='left-nav-panel-layout'>
            <div className='left-nav-panel'>
                {navigationItems.map((item) =>
                    <SingleLeftPanelItem
                        key={item.id}
                        item={item}
                        isActive={isActiveRoute(item.path)}
                        onClick={() => handleNavItemClick(item)}
                    />
                )}
            </div>
            <div className='left-nav-content'>
                <Suspense fallback={<LoadingIndicator />}>
                    <Switch>
                        {navigationItems.map((item) =>
                            <Route
                                key={item.id}
                                path={item.path}
                                render={(routeProps) =>
                                    <item.component
                                        {...routeProps}
                                        {...(item.componentProps || {})}
                                    />
                                }
                            />
                        )}
                        {/* Default redirect to first available item */}
                        <Route exact path={basePath}>
                            <Redirect to={defaultRoute} />
                        </Route>
                        <Redirect from={`${basePath}/*`} to={defaultRoute} />
                    </Switch>
                </Suspense>
            </div>
        </div>
    );
};

LeftNavLayoutComponent.propTypes = {
    navigationItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.elementType.isRequired,
            path: PropTypes.string.isRequired,
            component: PropTypes.elementType.isRequired,
            componentProps: PropTypes.object,
            requiredCapability: PropTypes.string,
            onClick: PropTypes.func
        })
    ).isRequired,
    defaultRoute: PropTypes.string.isRequired,
    basePath: PropTypes.string.isRequired
};

export default LeftNavLayoutComponent;
